import config from '../config';

/**
 * Authentication service for handling magic links and sessions
 */
class AuthService {
    /**
     * Send a magic link to the provided email
     * @param {string} email - User's email address
     * @returns {Promise} Response from the API
     */
    async sendMagicLink(email) {
        try {
            const response = await fetch(`${config.api.url}/magicLink`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });
            
            return await response.json();
        } catch (error) {
            console.error('Error sending magic link:', error);
            throw error;
        }
    }

    /**
     * Verify a magic link token
     * @param {string} token - Magic link token from URL
     * @returns {Promise} Response from the API
     */
    async verifyMagicLink(token) {
        try {
            const response = await fetch(`${config.api.url}/api/authentication/verify?token=${token}`);
            return await response.json();
        } catch (error) {
            console.error('Error verifying magic link:', error);
            throw error;
        }
    }

    /**
     * Check if the user is authenticated
     * @returns {Promise<boolean>} Authentication status
     */
    async checkSession() {
        try {
            const response = await fetch(`${config.api.url}/api/authentication/checkSession`, {
            });
            
            const data = await response.json();
            return data.authenticated;
        } catch (error) {
            console.error('Error checking session:', error);
            return false;
        }
    }

    /**
     * Parse token from URL query parameters
     * @returns {string|null} Magic link token or null
     */
    getTokenFromUrl() {
        const params = new URLSearchParams(window.location.search);
        return params.get('token');
    }
}

export default new AuthService(); 